import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HtmlContentComponent } from './html-content.component';

@NgModule({
  declarations: [HtmlContentComponent],
  imports: [CommonModule],
  exports: [HtmlContentComponent],
})
export class HtmlContentModule {}
